var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10508",
    "data-name": "Group 10508",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2353",
    "data-name": "Rectangle 2353",
    width: 30,
    height: 30,
    fill: "#99abb3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10507",
    "data-name": "Group 10507",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27861",
    "data-name": "Path 27861",
    d: "M21.131,14.348a8.478,8.478,0,1,0-12.263,0A15.061,15.061,0,0,0,0,28.043,1.924,1.924,0,0,0,1.957,30H28.043A1.924,1.924,0,0,0,30,28.043a15.061,15.061,0,0,0-8.869-13.7m-10.7-5.87A4.565,4.565,0,1,1,15,13.043a4.536,4.536,0,0,1-4.565-4.565M4.11,26.087a11.059,11.059,0,0,1,21.779,0Z",
    fill: "#99abb3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.e0eb36385edbb252f9d623dcec227ad7.svg";
export { ForwardRef as ReactComponent };